<template>
  <div class="customerOrderDetailPage">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane
        :label="$l('INDEX.order_tab_base_information') || '基本信息'"
        name="base"
      >
        <OrderInfo
          ref="base"
          :changeOrderCode="code"
          :disabled="isDisableEditForm"
        />
        <div
          class="d-flex justify-content-end mt-2 mb-2"
          v-if="!isDisableEditForm"
        >
          <el-button type="primary" size="small" @click="save()">{{
            $l('INDEX.btn_save') || '保存'
          }}</el-button>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_order_goods') || '产品信息'"
        name="goods"
        lazy
      >
        <OrderGoods :changeOrderCode="code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_demand_fabric') || '产品面料'"
        name="demandFabric"
        lazy
      >
        <DemandFabric :changeOrderCode="code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_tech_doc') || '工艺说明'"
        name="techDoc"
        lazy
      >
        <TechDoc :changeOrderCode="code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.tab_doc') || '订单文件'"
        name="orderDoc"
        lazy
      >
        <OrderDoc :changeOrderCode="code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_demand_material') || '产品辅料'"
        name="demandMabric"
        lazy
      >
        <DemandMaterial :changeOrderCode="code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.tab_goods_package_size') || '产品包装'"
        name="goodsPackage"
        lazy
      >
        <GoodsPackage :changeOrderCode="code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_demand_package') || '外包装箱'"
        name="demandPackage"
        lazy
      >
        <DemandPackage :changeOrderCode="code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.tab_demand_packing') || '装箱方案'"
        name="demandPacking"
        lazy
      >
        <DemandPacking :changeOrderCode="code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_sample_request') || '样品需求'"
        name="sampleRequest"
        lazy
      >
        <Proofing :changeOrderCode="code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_delivery_batch') || '交货批次'"
        name="batch"
        lazy
      >
        <OrderBatch :changeOrderCode="code" :disabled="isDisableEditForm" />
      </el-tab-pane>
      <el-tab-pane
        :label="$l('INDEX.order_tab_inspection_requirements') || '验货要求'"
        name="checkRequest"
        lazy
      >
        <OrderInspection
          :changeOrderCode="code"
          :disabled="isDisableEditForm"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import OrderInfo from '../../changeorder/components/info'
import OrderGoods from '../../changeorder/components/goods'
import DemandFabric from '../../changeorder/components/demand-fabric'
import TechDoc from '../../changeorder/components/tech-doc'
import OrderDoc from '../../changeorder/components/order-doc'
import DemandMaterial from '../../changeorder/components/demand-material'
import GoodsPackage from '../../changeorder/components/goods-package'
import DemandPackage from '../../changeorder/components/demand-package'
import DemandPacking from '../../changeorder/components/demand-packing'
import Proofing from '../../changeorder/components/proofing'
import OrderBatch from '../../changeorder/components/batch'
import OrderInspection from '../../changeorder/components/inspection'

export default {
  components: {
    OrderInfo,
    OrderGoods,
    DemandFabric,
    TechDoc,
    OrderDoc,
    DemandMaterial,
    GoodsPackage,
    DemandPackage,
    DemandPacking,
    Proofing,
    OrderBatch,
    OrderInspection,
  },
  props: {
    isDisableEditForm: Boolean,
    code: String,
  },
  data() {
    return {
      activeName: 'base',
    }
  },
  computed: {},
  methods: {},
}
</script>
